import React from 'react';
import Text from 'ui/Text';
import { FormattedMessage } from 'react-intl';

import whoWeAre from 'assets/who-we-are-bg.jpg';

const WhoWeAre = () => {
  return (
    <div
      id="who-we-are"
      className="row no-margin who-we-are"
      style={{ backgroundImage: `url(${whoWeAre})` }}>
      <div className="col-sm-12 col-md-7 col-lg-7 pitch">
        <Text type="sub-head" modifiers="near-black heavy title">
          <FormattedMessage id="WhoWeAre.Title" defaultMessage="Who We Are" />
          <span className="fake-border fake-border__underline" />
        </Text>
        <Text type="explanation" modifiers="near-black text-justify">
          <FormattedMessage
            id="WhoWeAre.Explanation"
            defaultMessage="EPIC-Africa seeks to enhance philanthropic
            impact by filling critical data and capacity gaps in the
            philanthropic market infrastructure in Africa. Our work
            helps to propel African civil society organizations to
            higher standards of performance, accountability, and
            transparency while inspiring greater local legitimacy and support."
          />
        </Text>
        <a
          className="btn btn-primary cta__landing-page"
          href="http://www.epic-africa.org/"
          target="_blank"
          rel="noopener noreferrer">
          <Text>
            <FormattedMessage id="WhoWeAre.Visit" defaultMessage="Visit Our Site" />
          </Text>
        </a>
      </div>
    </div>
  );
};

export default WhoWeAre;



// WEBPACK FOOTER //
// ./src/components/HomePage/WhoWeAre.js